import { del, get, post, put } from '@/lib/api.js';
import { ROUTE_APP } from 'shared/schema/staffAccess.js';

// Restricted organizations for MindCloud staff (docs/plans/active/api/2026-10-22-restricted-org-staff-access/).
const encodeSearch = (search) => (search ? encodeURIComponent(search) : undefined);

export const getMyStaffAccess = ({ companyId }, callback) => {
  return get('v1/staff-access/requests/mine', {
    query: { companyId },
    action: 'GET_MY_STAFF_ACCESS',
    callback
  });
};

export const postStaffAccessRequest = ({ companyId, reason }, callback) => {
  return post('v1/staff-access/requests', {
    data: { companyId, app: ROUTE_APP.gravity, reason },
    action: 'POST_STAFF_ACCESS_REQUEST',
    callback
  });
};

export const getStaffAccessRequests = ({ status, app, search, limit, offset }, callback) => {
  return get('v1/staff-access/requests', {
    query: { status, app, search: encodeSearch(search), limit, offset },
    action: 'GET_STAFF_ACCESS_REQUESTS',
    callback
  });
};

export const postStaffAccessDecision = ({ requestId, decision }, callback) => {
  return post(`v1/staff-access/requests/${requestId}/decision`, {
    data: { decision },
    action: 'POST_STAFF_ACCESS_DECISION',
    callback
  });
};

export const postStaffAccessGrant = ({ companyId, userId, apps, reason }, callback) => {
  return post('v1/staff-access/grants', {
    data: { companyId, userId, apps, ...(reason ? { reason } : {}) },
    action: 'POST_STAFF_ACCESS_GRANT',
    callback
  });
};

export const deleteStaffAccessGrant = ({ grantId }, callback) => {
  return del(`v1/staff-access/grants/${grantId}`, {
    action: 'DELETE_STAFF_ACCESS_GRANT',
    callback
  });
};

export const getStaffAccessCompanies = ({ search, restrictedOnly, limit, offset }, callback) => {
  return get('v1/staff-access/companies', {
    query: { search: encodeSearch(search), restrictedOnly: restrictedOnly ? 'true' : undefined, limit, offset },
    action: 'GET_STAFF_ACCESS_COMPANIES',
    callback
  });
};

export const getStaffAccessCompany = ({ companyId }, callback) => {
  return get(`v1/staff-access/companies/${companyId}`, {
    action: 'GET_STAFF_ACCESS_COMPANY',
    callback
  });
};

export const putStaffAccessRestricted = ({ companyId, restricted }, callback) => {
  return put(`v1/staff-access/companies/${companyId}/restricted`, {
    data: { restricted },
    action: 'PUT_STAFF_ACCESS_RESTRICTED',
    callback
  });
};
